import React, {useState} from 'react'
import {Input, Radio} from 'antd'

let searchThrottle

const SearchFields = ({searchQuery, searchSeason, setSearchSeason, setSearchQuery}) => {
  const [currentInput, setCurrentInput] = useState(searchQuery)

  const performSearch = (query) => {
    clearTimeout(searchThrottle)
    searchThrottle = setTimeout(() => setSearchQuery(query), 600)
  }

  const searchFieldUpdated = (evt) => {
    const value = evt.target.value
    setCurrentInput(value)
    performSearch(value)
  }

  const changeSeason = (e) => setSearchSeason(e.target.value)

  return (
    <div className="search-fields">
      <div className="season">
        <span>Vis:</span>
        <Radio.Group
          value={searchSeason}
          onChange={changeSeason}
        >
          <Radio value="">Alle</Radio>
          <Radio value="spring">Vår</Radio>
          <Radio value="summer">Sommer</Radio>
          <Radio value="fall">Høst</Radio>
          <Radio value="winter">Vinter</Radio>
        </Radio.Group>
      </div>

      <div className="search-query">
      <Input
        size="large"
        placeholder="Søk etter sted eller landemerke"
        value={currentInput}
        onChange={searchFieldUpdated}
      />
      </div>
    </div>
  )
}

export default SearchFields
